export default (
  state = {
    isFetchingCourse: false,
    selectedCourseCode: null,
    selectedCourse: null,
  },
  action,
) => {
  switch (action.type) {
    case 'SELECT_COURSE':
      return {
        ...state,
        selectedCourseCode: action.courseCode,
      }
    case 'REQUEST_COURSE':
      return {
        ...state,
        isFetchingCourse: true,
      }
    case 'RECEIVE_COURSE':
      return {
        ...state,
        isFetchingCourse: false,
        selectedCourse: action.course,
      }
    default:
      return state
  }
}
